module.exports = __webpack_public_path__ + "img/facts-canopy.651292e8.png";